// A file dropped on the Copilot panel goes through the same allowlist and the
// same count as the paperclip (agent-experience §5); size and downscale stay in
// prepareMediaFiles at send time — one pipeline for every entry point.
import { MEDIA_LIMITS, wholeMegabytes } from "./media-limits";
import { MEDIA_MESSAGES, mediaTypeOf, modalityOf, type MediaModality } from "./media-prep";

// The overlay names only the kinds this clinic's assistant reads (capabilities `inputModalities`).
const OVERLAY_KINDS: ReadonlyArray<[MediaModality, string]> = [["image", "Foto (JPG, PNG, WEBP, HEIC)"], ["pdf", "PDF"]];

export const DROP_COPY = {
  overlay: (modalities: readonly MediaModality[]) => {
    const kinds = OVERLAY_KINDS.filter(([modality]) => modalities.includes(modality)).map(([, text]) => text);
    const size = `até ${wholeMegabytes(MEDIA_LIMITS.maxFileBytes)} MB por arquivo`;
    return ["Solte para anexar ao pedido", ...(kinds.length > 0 ? [kinds.join(" ou ")] : []), size].join(" · ");
  },
  /** The toast title of every refused attachment: drop, paperclip, paste and send-time preparation. */
  notSent: "Anexo não enviado",
  noCapability: "Este assistente não lê arquivos nesta clínica.",
} as const;

export type DropResult = { files: File[]; notice: string | null };

export function acceptDroppedFiles(
  files: readonly File[],
  options: { modalities: readonly MediaModality[]; attached: number },
): DropResult {
  if (options.modalities.length === 0) return { files: [], notice: DROP_COPY.noCapability };
  const room = Math.max(0, MEDIA_LIMITS.maxAttachments - options.attached);
  const accepted: File[] = [];
  let notice: string | null = null;
  for (const file of files) {
    const modality = modalityOf(mediaTypeOf(file));
    if (!modality || !options.modalities.includes(modality)) {
      notice = MEDIA_MESSAGES.unsupported;
      continue;
    }
    if (accepted.length >= room) {
      notice = MEDIA_MESSAGES.turnTooLarge;
      continue;
    }
    accepted.push(file);
  }
  return { files: accepted, notice };
}
